import { ChainSymbol, TokenSymbol } from './types/TokenSymbol';

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export const ZERO_ADDRESS2 = '0x000000000000000000000000000000000000dead';


export enum BlockchainNetworkId {
  mainnet = 1,
  ropsten = 3,
  goerli = 5,
  smartchain = 56,
  ankrTest = 12077,
  sepolia = 11155111,
  bscscanTest = 97,
  opbnbTest = 5611,
  opbnb = 204,

}

const NativeTokens: {
  [key in BlockchainNetworkId]: TokenSymbol;
} = {
  [BlockchainNetworkId.mainnet]: TokenSymbol.ETH,
  [BlockchainNetworkId.ropsten]: TokenSymbol.ETH,
  [BlockchainNetworkId.goerli]: TokenSymbol.ETH,
  [BlockchainNetworkId.sepolia]: TokenSymbol.ETH,
  [BlockchainNetworkId.smartchain]: TokenSymbol.BNB,
  [BlockchainNetworkId.ankrTest]: TokenSymbol.ANKR,
  [BlockchainNetworkId.bscscanTest]: TokenSymbol.BNB,
  [BlockchainNetworkId.opbnb]: TokenSymbol.BNB,
  [BlockchainNetworkId.opbnbTest]: TokenSymbol.BNB,

};

const ChainsInfo = {
  [BlockchainNetworkId.mainnet]: { chainSymbolName: ChainSymbol.ETH },
  [BlockchainNetworkId.ropsten]: { chainSymbolName: ChainSymbol.ETH },
  [BlockchainNetworkId.goerli]: { chainSymbolName: ChainSymbol.ETH },
  [BlockchainNetworkId.sepolia]: { chainSymbolName: ChainSymbol.ETH },
  [BlockchainNetworkId.smartchain]: { chainSymbolName: ChainSymbol.BNB },
  [BlockchainNetworkId.ankrTest]: { chainSymbolName: ChainSymbol.ANKR },
  [BlockchainNetworkId.bscscanTest]: { chainSymbolName: ChainSymbol.BNB },
  [BlockchainNetworkId.opbnb]: { chainSymbolName: ChainSymbol.BNB },
  [BlockchainNetworkId.opbnbTest]: { chainSymbolName: ChainSymbol.BNB },

};

export function getChainSymbol(chainId: BlockchainNetworkId) {
  return ChainsInfo[chainId];
}

export function getNativeTokenSymbol(chainId: BlockchainNetworkId) {
  return NativeTokens[chainId];
}


export const BlockChainExplorerAddress: { [key in BlockchainNetworkId]: String} = {
  [BlockchainNetworkId.mainnet]: 'https://etherscan.io/',
  [BlockchainNetworkId.ropsten]: 'https://ropsten.etherscan.io/',
  [BlockchainNetworkId.goerli]: 'https://goerli.etherscan.io/',
  [BlockchainNetworkId.smartchain]: 'https://bscscan.com/',
  [BlockchainNetworkId.ankrTest]: 'https://testnetscan.ankr.com/',
  [BlockchainNetworkId.sepolia]: 'https://testnetscan.ankr.com/',
  [BlockchainNetworkId.bscscanTest]: 'https://testnetscan.ankr.com/',
  [BlockchainNetworkId.opbnb]: 'https://opbnbscan.com/',
  [BlockchainNetworkId.opbnbTest]: 'https://testnet.opbnbscan.com/',
};

export const getBlockChainExplorerAddress = (chainId?: BlockchainNetworkId) => {
  if (chainId && BlockChainExplorerAddress && BlockChainExplorerAddress[chainId]){
    return BlockChainExplorerAddress[chainId]
  }
  return '';
  // return process.env.REACT_APP_BLOCK+'/'
};
export const getBlockChainExplorerERCAddress = (chainId?: BlockchainNetworkId) => {
  if (chainId && BlockChainExplorerAddress && BlockChainExplorerAddress[chainId]){
    return BlockChainExplorerAddress[chainId]
  }
  return '';
};

const BlockChainExplorerName: { [key in BlockchainNetworkId]: String} = {
  [BlockchainNetworkId.mainnet]: 'ETHScan',
  [BlockchainNetworkId.ropsten]: 'RopstenScan',
  [BlockchainNetworkId.smartchain]: 'BSCScan',
  [BlockchainNetworkId.goerli]: 'Goerli',
  [BlockchainNetworkId.sepolia]: 'Sepolia',
  [BlockchainNetworkId.ankrTest]: 'Ankr',
  [BlockchainNetworkId.bscscanTest]: 'BSCScan',
  [BlockchainNetworkId.opbnb]: 'BSCScan',
  [BlockchainNetworkId.opbnbTest]: 'BSCScan',

};

export const getBlockChainExplorerName = (chainId: BlockchainNetworkId) =>
  BlockChainExplorerName[chainId];

const BlockChainTokenSymbol: {
  [key in BlockchainNetworkId]: String;
} = {
  [BlockchainNetworkId.mainnet]: TokenSymbol.ETH,
  [BlockchainNetworkId.ropsten]: TokenSymbol.ETH,
  [BlockchainNetworkId.goerli]: TokenSymbol.ETH,
  [BlockchainNetworkId.sepolia]: TokenSymbol.ETH,
  [BlockchainNetworkId.smartchain]: TokenSymbol.BNB,
  [BlockchainNetworkId.ankrTest]: TokenSymbol.ANKR,
  [BlockchainNetworkId.bscscanTest]: TokenSymbol.BNB,
  [BlockchainNetworkId.opbnb]: TokenSymbol.BNB,
  [BlockchainNetworkId.opbnbTest]: TokenSymbol.BNB,

};

export const DefaultTokenSymbol = TokenSymbol.BNB;
export const DefaultChainId = BlockchainNetworkId.opbnb;


export const getTokenSymbol = (chainId: BlockchainNetworkId) =>
  BlockChainTokenSymbol[chainId] || DefaultTokenSymbol;

export enum NftFtKeys {
  NFT,
  FT,
}

export const NftFtTabs = [
  {
    label: 'NFT',
    value: NftFtKeys.NFT,
  },
  {
    label: 'FT',
    value: NftFtKeys.FT,
  },
];
const baseEnv = process.env.REACT_APP_BASE_ENV;
export const isChainSupported = baseEnv === "development" ? [BlockchainNetworkId.opbnbTest] : [BlockchainNetworkId.opbnb];


